import { useContext, useEffect } from 'react';

import { EmbedContext } from './EmbedProvider';
import useUrlState from '../../common/useUrlState';

const useAutoScrollToSection = () => {
  const { scrollToSection } = useContext(EmbedContext);

  const [urlState, setUrlState] = useUrlState({
    parse: (params, { string }) => ({
      ...params,
      section: string(params.section),
    }),
  });

  useEffect(() => {
    if (urlState.section) {
      scrollToSection(urlState.section, undefined, 0);

      setUrlState((state) => ({
        ...state,
        section: undefined,
      }), true);
    }
  }, [scrollToSection, urlState.section, setUrlState]);
};

export default useAutoScrollToSection;
